import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    numericRanking: {
        composes: "numericRanking",
    },
    numericOptionList: {
        composes: "numeric-option-list",
    },
    numericOption: {
        composes: "numeric-option",
    },
    numericOptionChoiceTextHeader: {
        composes: "numeric-option__choice-text-header",
    },
    numericOptionChoiceRankingHeader: {
        composes: "numeric-option__choice-ranking-header",
    },
    numericOptionChoiceHeader: {
        composes: "numeric-option__choice-header",
        paddingBottom: "13px",
        paddingTop: "13px",
    },
    numericOptionChoiceText: {
        composes: "numeric-option__choice-text",
        paddingBottom: "13px",
        paddingRight: "24px",
        paddingTop: "13px",
        verticalAlign: "middle",
    },
    numericOptionChoiceRanking: {
        composes: "numeric-option__choice-ranking",
        paddingRight: "24px",
        verticalAlign: "middle",
    },
    numericOptionChoiceInput: {
        composes: "numeric-option__choice-Input",
    },
    numericOptionChoiceLabel: {
        composes: "numeric-option__choice-label",
    },
    numericOptionChoiceSelected: ({ theme }) => ({
        background: theme.PrimaryColor,
        color: Mixins.foregroundColor(theme, theme.PrimaryColor),
        composes: "numeric-option__choice-ranking--selected",
    }),
});
